import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxMaterialModule } from '@impesa/ngx-core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-kyc-alert-exblk',
  standalone: true,
  imports: [CommonModule, RouterModule, NgxMaterialModule, TranslateModule],
  templateUrl: './kyc-alert-exblk.component.html',
  styleUrls: ['./kyc-alert-exblk.component.scss'],
})
export class KycAlertEXBLKComponent {}
